/* tslint:disable */
/* eslint-disable */
/**
 * extractor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface Filtre {
    'geo'?: GeoRef;
    'typesDeBiens'?: Array<TypeDeBiens>;
    'syndic'?: boolean;
    'copro'?: boolean;
    'nbLgts'?: number;
    'Dpes'?: Array<string>;
    'output'?: GeoLocOutput;
}



export const GeoLocOutput = {
    BanLatLon: 'BAN_LAT_LON',
    BanSecondaryLatLon: 'BAN_SECONDARY_LAT_LON',
    PolygonBatGroupe: 'POLYGON_BAT_GROUPE',
    PolygonConstructionGroupe: 'POLYGON_CONSTRUCTION_GROUPE',
    PolygonParcelle: 'POLYGON_PARCELLE'
} as const;

export type GeoLocOutput = typeof GeoLocOutput[keyof typeof GeoLocOutput];


export interface GeoRef {
    'batimentGroupeId'?: string;
    'commune'?: string;
    'departement'?: string;
    'region'?: string;
    'epci'?: string;
}

export const TypeDeBiens = {
    SurfaceUtile: 'SURFACE_UTILE',
    TypeDeProprietaire: 'TYPE_DE_PROPRIETAIRE',
    TypeDeBatiment: 'TYPE_DE_BATIMENT',
    PeriodeDeConstruction: 'PERIODE_DE_CONSTRUCTION'
} as const;

export type TypeDeBiens = typeof TypeDeBiens[keyof typeof TypeDeBiens];



/**
 * ApiExtractorCtrlApi - axios parameter creator
 */
export const ApiExtractorCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Bdndb All
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbAllPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbAllPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Batiment Construction
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentConstructionPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentConstructionPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiment_construction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Batiment Groupe Adresse
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeAdressePost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentGroupeAdressePost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiment_groupe_adresse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Batiment Groupe Adresses
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeAdressesPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentGroupeAdressesPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiment_groupe_adresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Batiment Groupe
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupePost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentGroupePost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiment_groupe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Batiment Groupe Rnc
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeRncPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentGroupeRncPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiment_groupe_rnc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exportbatiment _groupe _synthese _propriete _usage
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeSyntheseProprieteUsagePost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentGroupeSyntheseProprieteUsagePost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiment_groupe_synthese_propriete_usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Batiments
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentsPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbBatimentsPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/batiments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Parcelles
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbParcellesPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbParcellesPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/parcelles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Proprietaires
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbPropPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbPropPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/prop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Dpe Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDpePost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiDpePost', 'filtre', filtre)
            const localVarPath = `/api/dpe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Etab Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEtabPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiEtabPost', 'filtre', filtre)
            const localVarPath = `/api/etab`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Com From Epci
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiListEpciGet: async (iris?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/list/epci`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (iris !== undefined) {
                localVarQueryParameter['iris'] = iris;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Rnc Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRncPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiRncPost', 'filtre', filtre)
            const localVarPath = `/api/rnc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiExtractorCtrlApi - functional programming interface
 */
export const ApiExtractorCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiExtractorCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Bdndb All
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbAllPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<{ [key: string]: string; }>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbAllPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Batiment Construction
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentConstructionPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentConstructionPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentConstructionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Batiment Groupe Adresse
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentGroupeAdressePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentGroupeAdressePost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentGroupeAdressePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Batiment Groupe Adresses
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentGroupeAdressesPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentGroupeAdressesPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentGroupeAdressesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Batiment Groupe
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentGroupePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentGroupePost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentGroupePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Batiment Groupe Rnc
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentGroupeRncPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentGroupeRncPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentGroupeRncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exportbatiment _groupe _synthese _propriete _usage
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentGroupeSyntheseProprieteUsagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Batiments
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbBatimentsPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbBatimentsPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbBatimentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Parcelles
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbParcellesPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbParcellesPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbParcellesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Proprietaires
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbPropPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbPropPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbPropPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Dpe Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDpePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDpePost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiDpePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Etab Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEtabPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEtabPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiEtabPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get List Com From Epci
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiListEpciGet(iris?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiListEpciGet(iris, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiListEpciGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Rnc Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRncPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRncPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiRncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiExtractorCtrlApi - factory interface
 */
export const ApiExtractorCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiExtractorCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Bdndb All
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbAllPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<{ [key: string]: string; }>; }> {
            return localVarFp.apiBdnbAllPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Batiment Construction
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentConstructionPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentConstructionPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Batiment Groupe Adresse
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeAdressePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentGroupeAdressePost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Batiment Groupe Adresses
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeAdressesPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentGroupeAdressesPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Batiment Groupe
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentGroupePost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Batiment Groupe Rnc
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeRncPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentGroupeRncPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exportbatiment _groupe _synthese _propriete _usage
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Batiments
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbBatimentsPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbBatimentsPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Parcelles
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbParcellesPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbParcellesPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Proprietaires
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbPropPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiBdnbPropPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Dpe Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDpePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiDpePost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Etab Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEtabPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiEtabPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Com From Epci
         * @param {string} [iris] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiListEpciGet(iris?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiListEpciGet(iris, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Rnc Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRncPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiRncPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiExtractorCtrlApi - object-oriented interface
 */
export class ApiExtractorCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Export Bdndb All
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbAllPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbAllPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Batiment Construction
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentConstructionPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentConstructionPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Batiment Groupe Adresse
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentGroupeAdressePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentGroupeAdressePost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Batiment Groupe Adresses
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentGroupeAdressesPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentGroupeAdressesPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Batiment Groupe
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentGroupePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentGroupePost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Batiment Groupe Rnc
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentGroupeRncPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentGroupeRncPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exportbatiment _groupe _synthese _propriete _usage
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentGroupeSyntheseProprieteUsagePost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Batiments
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbBatimentsPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbBatimentsPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Parcelles
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbParcellesPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbParcellesPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Proprietaires
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbPropPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbPropPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Dpe Data
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDpePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiDpePost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Etab Data
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEtabPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiEtabPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Com From Epci
     * @param {string} [iris] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiListEpciGet(iris?: string, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiListEpciGet(iris, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Rnc Data
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiRncPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiRncPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



